import DTO from './DTO';
import DtoType from './converters/DtoType';
import PresetDayDTO from './PresetDayDTO';

class PresetDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'id',
      },
      {
        name: 'name',
        type: String,
        validators: {},
        labelKey: 'preset.name',
      },
      {
        name: 'start',
        type: String,
        validators: {},
        labelKey: 'preset.start',
      },
      {
        name: 'end',
        type: String,
        validators: {},
        labelKey: 'preset.end',
      },
      {
        name: 'interval',
        type: String,
        validators: {},
        labelKey: 'preset.interval',
      },
      {
        name: 'save_intermediate',
        type: Boolean,
        validators: {},
        labelKey: 'preset.save_intermediate',
      },
      {
        name: 'show_intermediate',
        type: String,
        validators: {},
        labelKey: 'preset.show_intermediate',
      },
      {
        name: 'days',
        type: DtoType(PresetDayDTO),
        validators: {},
        labelKey: 'preset.days',
      },
      {
        name: 'violation_type_id',
        type: String,
        validators: {},
        labelKey: 'preset.violation_type_id',
      },
      {
        name: 'collage_settings',
        type: String,
        validators: {},
        labelKey: 'preset.collage_settings',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      id: this.id,
      name: this.name,
      start: this.start,
      end: this.end,
      interval: this.interval,
      save_intermediate: this.save_intermediate,
      show_intermediate: this.show_intermediate,
      days: this.days,
      violation_type_id: this.violation_type_id,
      collage_settings: this.collage_settings,
    };
  }
}

export default PresetDTO;
